import {NgIf} from '@angular/common';
import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-gs-build-run',
	templateUrl:'./BuildAndRunPage.html',
	styles: [],
	styleUrls:['./BuildAndRunPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		NgIf,
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BuildAndRunPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_33 = `\`\`\`java
mvn clean install
\`\`\``;
	mdContent_34 = `\`\`\`bash
./gradlew build
\`\`\``;
	mdContent_35 = `\`\`\`bash
# The built SPA is in target/webroot/
# Serve it however you like — nginx, Apache, CDN, or:
npx serve target/webroot/my-app
\`\`\``;
	mdContent_36 = `\`\`\`bash
java -jar target/my-app.jar

# Open http://localhost:8080
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
